export enum RegistrationMenuEnum {
  VehicleUpgrades = 1
}
